export type PaginatedFilterOperator =
    "eq" |
    "ne" |
    "gt" |
    "gte" |
    "lt" |
    "lte" |
    "in" |
    "nin";

export const PAGINATED_FILTER_OPERATORS: PaginatedFilterOperator[] = [
    "eq",
    "ne",
    "gt",
    "gte",
    "lt",
    "lte",
    "in",
    "nin"
];

export interface PaginatedSort {
    field: string;
    direction: "asc" | "desc";
}

export interface PaginatedFilter {
    field: string;
    value: string | number | boolean | string[] | number[] | boolean[] | null;
    operator: PaginatedFilterOperator;
}

export interface PaginatedRequest {
    offset: number;
    size: number;
    sort?: PaginatedSort[];
    filters?: PaginatedFilter[];
}

export interface PaginatedResponse<TItem> {
    offset: number;
    size: number;
    total: number;
    items: TItem[];
}
